import { render, staticRenderFns } from "./PlanDocument.vue?vue&type=template&id=4c095172&scoped=true"
import script from "./PlanDocument.vue?vue&type=script&lang=js"
export * from "./PlanDocument.vue?vue&type=script&lang=js"
import style0 from "./PlanDocument.vue?vue&type=style&index=0&id=4c095172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c095172",
  null
  
)

export default component.exports